export const LIMITED_ERROR_COMBO_NOT_ENOUGH = 'limited-error-combo-not-enough'
